import { styled } from '@mui/material/styles';

// TODO Remove : Useless code
export const Flex = styled('div')({
  display: 'flex',
});
